import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type State = {
  defaultFilter: string,
	defaultTypeFilter: number
}

export type Action = {
  actions?: {
    setDefaultFilter: (filter: string) => void
		setDefaultTypeFilter: (type: number) => void
  }
}

export const useProductSearchInputStore = create(
  persist<State & Action>(
    (set) => ({
      defaultFilter: 'referencia_afere',
			defaultTypeFilter: 2,
      actions: {
				setDefaultTypeFilter: (type) => {
					set({
						defaultTypeFilter: type,
					})
				},
        setDefaultFilter: (filter) => {
          set({
            defaultFilter: filter,
          })
        },
      },
    }),
    {
      name: 'search-product-input',
      partialize: (state) => ({
        defaultFilter: state.defaultFilter,
				defaultTypeFilter: state.defaultTypeFilter
      }),
    },
  ),
)
